import type { IconData } from '@stacksjs/iconify-core'

export const steps1Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 17a7 7 0 1 0 6.54 9.5h2.92a7.003 7.003 0 0 0 13.08 0h2.92A7.003 7.003 0 0 0 47 24a7 7 0 0 0-13.54-2.5h-2.92a7.003 7.003 0 0 0-13.08 0h-2.92A7 7 0 0 0 8 17m32 4a3 3 0 1 0 0 6a3 3 0 0 0 0-6m-19 3a3 3 0 1 1 6 0a3 3 0 0 1-6 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default steps1Remix
